// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@guestsupply/MobiusOverrides/TextField/TextField";
import { xScreen } from "@guestsupply/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

customerAddressFormFieldStyles.container = {
    offsetCss: css`
        &&&& {
            ${xScreen("lt", "xs")} {
                & > ${GridItemStyle} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            }
        }
    `,
};

customerAddressFormFieldStyles.emailGridItem = {
    width: 6,
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("First Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Last Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Company Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Address1"),
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Address2"),
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Address3"),
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Address4"),
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("City"),
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Postal Code"),
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("Phone"),
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("Fax"),
} as TextFieldProps;

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Email"),
} as TextFieldProps;
